export default __webpack_public_path__ + "static/media/home-1.2f051453.jpg";